import { compose } from 'recompose';
import CampaignsDetails from './Details';
import {
  query, mutation, CREATE_CAMPAIGN
} from './API';
import withRequestTracker from '../../../../utils/composition/withRequestTracker';

const ComposedCampaignsDetails = compose(
  CREATE_CAMPAIGN,
  withRequestTracker({
    query,
    mutation,
  }),
)(CampaignsDetails);

export default ComposedCampaignsDetails;
